import { render, staticRenderFns } from "./NavMegaPanel.vue?vue&type=template&id=bee5333a&scoped=true"
import script from "./NavMegaPanel.vue?vue&type=script&lang=js"
export * from "./NavMegaPanel.vue?vue&type=script&lang=js"
import style0 from "./NavMegaPanel.vue?vue&type=style&index=0&id=bee5333a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee5333a",
  null
  
)

export default component.exports